import ListWithIcons from '@/common/components/list-with-icons';
import CarEmergencyLight from '@/icons/car-emergency-light';
import FuelSmallDarkGradient from '@/icons/fuel-small-dark-gradient';
import WrenchSmallDarkGradient from '@/icons/wrench-small-dark-gradient';
import { colors } from '@/theme/colors';

interface PDPSubscriptionFeaturesProps {
  gasSaverCents: string;
  className?: string;
}

export default function PDPSubscriptionFeatures({
  gasSaverCents,
  className,
}: PDPSubscriptionFeaturesProps) {
  return (
    <ListWithIcons
      items={[
        {
          icon: (
            <WrenchSmallDarkGradient
              className="mt-[2px] flex-shrink-0"
              fillPrimary={colors.neutral1}
            />
          ),
          title: 'Comprehensive maintenance',
          description: 'Oil changes, tires, brakes, engine, & more',
          textGap: 2,
          titleClassName: 'body2-tight font-semibold',
          descriptionClassName: 'body3-tight text-[14px] tracking-normal leading-[20px]',
        },
        {
          icon: <FuelSmallDarkGradient className="mt-[1px] flex-shrink-0" />,
          title: 'Flexcar Gas Saver™',
          description: `Save ${gasSaverCents}/gal at Sunoco every time`,
          variantDescription: 'gradient',
          textGap: 2,
          titleClassName: 'body2-tight font-semibold',
          descriptionClassName:
            'body3-tight text-[14px] tracking-normal font-medium leading-[20px]',
        },
        {
          icon: <CarEmergencyLight className="mt-[2px] flex-shrink-0" />,
          title: '24/7 Roadside assistance',
          titleClassName: 'body2-tight font-semibold',
        },
      ]}
      className={className}
    />
  );
}
